export default __webpack_public_path__ + "static/media/detail_big_5_5.fb18eafd.png";